import { PermissionsCatalogContext } from '@shared/context'
import { useSessionContext } from '@shared/hooks'
import { normalizeApplicationCatalog } from '@shared/utils'
import { PropsWithChildren, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const PermissionsCatalogProvider = ({ children }: PropsWithChildren) => {
  const { i18n } = useTranslation()
  const { user, isLoading: isSessionLoading } = useSessionContext()

  const contextValue = useMemo(() => {
    const applications = Array.from(
      new Map(
        [
          ...(user?.pinned_applications || []),
          ...(user?.public_applications || [])
        ].map((application) => [application.id, application])
      ).values()
    )

    const catalogs = applications.map((application) =>
      normalizeApplicationCatalog(application, i18n.language)
    )

    return {
      catalogs,
      isLoading: isSessionLoading,
      getCatalogByType: (type: string) =>
        catalogs.find(({ applicationType }) => applicationType === type)
    }
  }, [user, i18n.language, isSessionLoading])

  return (
    <PermissionsCatalogContext.Provider value={contextValue}>
      {children}
    </PermissionsCatalogContext.Provider>
  )
}
